<template>
  <div class="switcher-wrapper">
    <div
      v-for="cfg in configTabComputed"
      :key="cfg.action"
      class="switcher-item">
      <input
        :id="`radio-${cfg.action}-1`"
        v-model="dataModelChecked"
        :value="cfg.action"
        type="radio"
        :name="`radio-${cfg.action}`"
        @click="clickAction('opened')">
      <label :for="`radio-${cfg.action}-1`">{{ cfg.name }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallCheckedClosedOpenedCustom',
  props: {
    value: {
      type: String,
      default: null
    },
    configTab: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      dataModelChecked: this.value,
      clickAction: null
    };
  },
  computed: {
    configTabComputed () {
      return this.configTab;
    }
  },
  watch: {
    dataModelChecked () {
      this.$emit('input', this.dataModelChecked);
    },
    value (v) {
      this.dataModelChecked = v;
    }
  },
  created () {
    let _type = this.value;
    this.clickAction = (type) => {
      if (_type === type) {
        return;
        // this.dataModelChecked = null;
      }
      _type = type;
    };
  }
};
</script>
